var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4852 11.0591V1.34477C13.4852 1.15313 13.3713 0.979797 13.1952 0.904375C13.0209 0.828008 12.8152 0.864077 12.6761 0.996212L7.91703 5.49087L8.59555 6.16939L12.5257 2.45788V10.0996L13.4852 11.0591ZM5.51234 6.62171H4.85007V12.3785H7.92614C8.04843 12.3785 8.16649 12.4253 8.25549 12.5096L12.5257 16.5424V13.6351L13.4852 14.5946V17.6555C13.4852 17.8471 13.3714 18.0205 13.1952 18.0959C13.1343 18.1226 13.0697 18.1352 13.0055 18.1352C12.8855 18.1352 12.767 18.0903 12.6761 18.004L7.7355 13.3379H4.37037C4.1052 13.3379 3.89062 13.1234 3.89062 12.8582V6.14202C3.89062 5.87689 4.1052 5.66232 4.37037 5.66232H4.55294L5.51234 6.62171Z",
    fill: "url(#paint0_linear_10_42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24609 1.64642L17.2461 17.6464",
    stroke: "url(#paint1_linear_10_42)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_42",
    x1: 3.89062,
    y1: -6.23835,
    x2: 26.2487,
    y2: 1.5681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15926,
    stopColor: "#FEFFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661725,
    stopColor: "#E6D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291A15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_42",
    x1: 1.53692,
    y1: 1.3556,
    x2: -1.1842,
    y2: 4.48835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15926,
    stopColor: "#FEFFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661725,
    stopColor: "#E6D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291A15"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound-off.6b80cbc0b83bedabe485c83834b1e267.svg";
export { ForwardRef as ReactComponent };